import Vuex from 'vuex';

import session from './modules/session';
import cameras from './modules/cameras';
import recordings from './modules/recordings';
import realtime from './modules/realtime';
import payment from './modules/payment';
import price from './modules/price';
import parking from './modules/parking';
import modal from './modules/modal';

export default new Vuex.Store({

    modules: {
        session,
        cameras,
        recordings,
        realtime,
        payment,
        price,
        parking,
        modal
    }

});
